import { useCallback, useEffect, useState, type ReactNode } from "react";
import type { Coverage } from "@aigov/domain";

export function Pill({ tone, children }: { tone: "crit" | "warn" | "info" | "mute" | "ok"; children: ReactNode }) {
  return <span className={`pill p-${tone}`}>{children}</span>;
}

export function Bar({ pct, width }: { pct: number; width?: number }) {
  return <div className="bar" style={{ width: width ?? "100%" }} role="img" aria-label={`${pct}%`}><i style={{ width: `${pct}%` }} /></div>;
}

export function CoverageCell({ c }: { c: Coverage }) {
  return <div className="row" style={{ flexWrap: "nowrap" }}><Bar pct={c.pct} width={70} /><span className="small">{c.pct}%</span></div>;
}

export function useToast() {
  const [msg, setMsg] = useState<string | null>(null);
  useEffect(() => {
    if (!msg) return;
    const t = setTimeout(() => setMsg(null), 2600);
    return () => clearTimeout(t);
  }, [msg]);
  const node = msg ? <div className="toast" role="status">{msg}</div> : null;
  return { toast: useCallback((m: string) => setMsg(m), []), node };
}

export function ErrorNote({ error }: { error: string | null }) {
  return error ? <div className="err" role="alert">{error}</div> : null;
}

export const errMsg = (e: unknown) => (e instanceof Error ? e.message : "Something went wrong");
